import { MMT_SERVER_URL, SERVER_URL } from "../constants/ClientConfig";
import { getCookie } from "./trainUtils";

export const APP_HOST = 'APP_HOST';
interface IdomainMapping {
  [key: string]: string;
}

const RAILS = 'RAILS';
const MMT = 'MMT';

const domainMapping: IdomainMapping = {
  'www.makemytrip.com': MMT,
  'rails.makemytrip.com': RAILS
}

const getHostName = (): string => {
  if (window && window.location && window.location.hostname) {
    return window.location.hostname;
  }
  return '';
}

export const getKeyFromDomain = (): string => domainMapping[getHostName()];

export const getServerUrl = () => {
  const currentDomain = getCookie(APP_HOST);
  if (currentDomain === MMT) {
    return MMT_SERVER_URL;
  }
  return SERVER_URL;
}
